"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = uuid;

function uuid() {
  var component = function component(_) {
    return Math.random().toString(16).slice(-4);
  };

  return component() + component() + '-' + component() + '-' + component() + '-' + component() + '-' + component() + component() + component();
}

;